
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserNotificationSettings"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canWriteIdeas"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"ideas","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"write","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessComments"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"idea_comments","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"access","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canViewCapIntro"},"name":{"kind":"Name","value":"isCapIntroMember"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessJobPostings"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"job_postings","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"access","block":false}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canReceiveViewerIntroRequest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userNotificationSetting"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showAll"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showActivelyDiscussed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showBadges"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showBiggestMovers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showCapIntro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showContests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showComments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showFolloweeActivity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showFollowers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showFundFollower"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showIdeas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showJobVault"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showViewerIntroRequests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showNewRecommended"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showRankings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showTrendingResearch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showWatchlist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showWhitePapers"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":808}};
    doc.loc.source = {"body":"query CurrentUserNotificationSettings {\n  currentUser {\n    id\n    canWriteIdeas: canAccess(resource: \"ideas\", permission: \"write\")\n    canAccessComments: canAccess(resource: \"idea_comments\", permission: \"access\")\n    canViewCapIntro: isCapIntroMember\n    canAccessJobPostings: canAccess(resource: \"job_postings\", permission: \"access\")\n    canReceiveViewerIntroRequest\n    userNotificationSetting {\n      id\n      showAll\n      showActivelyDiscussed\n      showBadges\n      showBiggestMovers\n      showCapIntro\n      showContests\n      showComments\n      showFolloweeActivity\n      showFollowers\n      showFundFollower\n      showIdeas\n      showJobVault\n      showViewerIntroRequests\n      showNewRecommended\n      showRankings\n      showTrendingResearch\n      showWatchlist\n      showWhitePapers\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CurrentUserNotificationSettings"] = oneQuery(doc, "CurrentUserNotificationSettings");
        
